import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ChangePasswordCard() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("New passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password changed.");
      setForm({ current_password: "", new_password: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change password.");
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button data-testid="open-change-password" onClick={() => setOpen(true)} className="btn-ghost" style={{ fontSize: 13 }}>
        Change password
      </button>
    );
  }

  return (
    <div className="bg-card" style={{ padding: 20, marginTop: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <div className="serif" style={{ fontSize: 20, color: "#fff" }}>Change your password</div>
        <button onClick={() => setOpen(false)} className="link-gold" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13 }}>Close</button>
      </div>
      <form onSubmit={submit} style={{ display: "grid", gap: 10 }}>
        <input data-testid="cp-current" required type="password" placeholder="Current password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="input-dark" />
        <input data-testid="cp-new" required type="password" minLength={6} placeholder="New password (min 6 chars)" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="input-dark" />
        <input data-testid="cp-confirm" required type="password" placeholder="Confirm new password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="input-dark" />
        <button data-testid="cp-submit" type="submit" disabled={busy} className="btn-gold" style={{ marginTop: 4 }}>{busy ? "Saving…" : "Update password"}</button>
      </form>
    </div>
  );
}
